import { render, staticRenderFns } from "./page-setup-extension.vue?vue&type=template&id=77f75472&"
import script from "./page-setup-extension.vue?vue&type=script&lang=js&"
export * from "./page-setup-extension.vue?vue&type=script&lang=js&"
import style0 from "./page-setup-extension.vue?vue&type=style&index=0&id=77f75472&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports